<template>
<div class="chapter">
<div class="inner_page">
<div class="frontMatter">
<div class="illustype_image"><div class="image" style="width:79%"><img alt="e9781439633854_i0004.jpg" src="images/e9781439633854_i0004.jpg"/></div>
<div class="caption"><p class="p"><span>John Vinall (1736–1823), for whom Vinalhaven was named, is shown here in this <em class="i">c.</em> 1785 portrait by John Mason Furness. He was a Bostonian, a “man of influence,” a teacher, a merchant, and an attorney. His son William had settled in the Fox Islands. When the inhabitants of the islands petitioned the General Court of Massachusetts for title to their lands, John was their attorney. North and South Fox Islands were incorporated as the town of Vinalhaven on June 25, 1789.</span></p></div></div></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// e9781439633854_fm03.vue?67beb0fe